import React, { useEffect, useState } from 'react';
import { MainPage } from '@bepro-travel/fe.shared';
import { getDest, visaAlpLogin } from '../services/visa.tsx';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { getPacImg } from '../utils.tsx';

const MainPageContent = () => {
  const [packages, setPackages] = useState<any>([]);
  const navigate = useNavigate();
  const [urlParams] = useSearchParams();
  const [_token, setToken] = useState<string>();

  useEffect(() => {
    const info = urlParams.get('info');
    if (info) {
      (async () => {
        const response = await visaAlpLogin({
          info: info,
          token: sessionStorage.getItem('alpToken') ?? undefined,
          language: 'He',
        });

        if (response) {
          setPackages(response.destinations);
          setToken(response.token);
          sessionStorage.setItem('alpToken', response.token);

          const header = document.querySelector('.header');
          if (header) {
            header.classList.add('header-img');
          }
        }
      })();
    } else {
      (async () => {
        const newPackages = await getDest();

        if (newPackages) {
          setPackages(newPackages);
        }
      })();
    }
  }, []); // eslint-disable-line

  const onSelectPackage = (countryCode: string) => {
    navigate('/packages?countryCode=' + countryCode);
  };

  return (
    <div>
      <div className="home" dir="rtl">
        <div className="home-titles mb-20 mt-10">
          ברוכים הבאים למחלקת ויזות של אמסלם תיירות ונופש
        </div>
        <MainPage pageName="" />

        <div className="home-titles">בחרו את היעד, אנחנו נדאג לשאר</div>
      </div>
      <div className="visa">
        {packages.map((item, index) => (
          <div
            key={index}
            className="visa-el"
            onClick={() => onSelectPackage(item.country.code)}
          >
            <div className="visa-flag">
              {!!getPacImg(item, false) && (
                <img src={getPacImg(item, false)} alt="1" />
              )}
            </div>
            <div className="visa-title">{item.languages[0].title.desc}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MainPageContent;
